import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useReducer } from 'react';

import actions from './actions';
import reducer from './reducer';

const initialState = {
  isLoading: false,
  defaultBrandId: null,
  brandList: [],
  localisations: [],
  brands: {},
  settingsByBrand: {},
  webSheets: {},
  count: 0,
};

/** React Context **/
const WebSheetContext = createContext(undefined);

/** Context Provider **/
export function WebSheetProvider({ children }) {
  const [newState, dispatch] = useReducer(reducer, initialState);
  const newActions = useMemo(() => actions(dispatch), [dispatch]);

  return (
    <WebSheetContext.Provider
      value={[newState, newActions]}
      displayName="WebSheetContext"
    >
      {children}
    </WebSheetContext.Provider>
  );
}

/** Hook wrapper for useContext **/
export const useWebSheetContext = () => {
  const context = useContext(WebSheetContext);

  if (!context) {
    throw new Error('useWebSheetContext must be used within WebSheetProvider');
  }
  return context;
};

WebSheetProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
